import React, { useEffect, Fragment } from 'react';
import {
    changeNameAll,
    changeTitle1All,
    changeTitle2All,
    changeDepartment1All,
    changeDepartment2All,
    changePhoneAll,
    changeFaxAll,
    changeNursePhoneAll,
    changeAddressAll,
    changeCityAll,
    changeStateAll,
    changeZipAll,
    changeSuiteRoomAll,
    changeWebsiteAll,
    changeEmailAll,
    changeLocationNamesAll,
    changeLocationPhonesAll,
    changeLocationFaxesAll,
    changeLocationNursePhonesAll,
    changeLocationAddresses1All,
    changeLocationCitiesAll,
    changeLocationStatesAll,
    changeLocationZipsAll,
    changeLocationSuitesAll,
    changeLocationsAll,
    changeAdditionalFieldAll,
    getAddressLineP1T16,
    isEmpty,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP1T16 = React.memo((props) => {
    useEffect(() => {
        changeNameAll(props.name);
    }, [props.name]);

    useEffect(() => {
        changeTitle1All(props.title1);
    }, [props.title1]);

    useEffect(() => {
        changeTitle2All(props.title2);
    }, [props.title2]);

    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2All(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changePhoneAll(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeFaxAll(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changeNursePhoneAll(props.nursePhone);
    }, [props.nursePhone]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeSuiteRoomAll(props.suiteRoom);
    }, [props.suiteRoom]);

    useEffect(() => {
        changeWebsiteAll(props.website);
    }, [props.website]);

    useEffect(() => {
        changeEmailAll(props.email);
    }, [props.email]);

    useEffect(() => {
        changeCityAll(props.city);
    }, [props.city]);

    useEffect(() => {
        changeStateAll(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZipAll(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeAdditionalFieldAll(props.additionalField);
    }, [props.additionalField]);

    useEffect(() => {
        changeLocationNamesAll(props.locationNames);
    }, [props.locationNames]);

    useEffect(() => {
        changeLocationPhonesAll(props.locationPhones);
    }, [props.locationPhones]);

    useEffect(() => {
        changeLocationFaxesAll(props.locationFaxes);
    }, [props.locationFaxes]);

    useEffect(() => {
        changeLocationNursePhonesAll(props.locationNursePhones);
    }, [props.locationNursePhones]);

    useEffect(() => {
        changeLocationAddresses1All(props.locationAddresses1);
    }, [props.locationAddresses1]);

    useEffect(() => {
        changeLocationCitiesAll(props.locationCities);
    }, [props.locationCities]);

    useEffect(() => {
        changeLocationStatesAll(props.locationStates);
    }, [props.locationStates]);

    useEffect(() => {
        changeLocationZipsAll(props.locationZips);
    }, [props.locationZips]);

    useEffect(() => {
        changeLocationSuitesAll(props.locationSuites);
    }, [props.locationSuites]);

    useEffect(() => {
        changeLocationsAll(props.locations);
    }, [props.locations]);

    const setLocationElement = (elements, setFunction, index, value) => {
        const elementsCopy = [...elements];
        elementsCopy[index] = value;
        setFunction(elementsCopy);
    };

    const handleSetAddress = (value) => {
        changeAddressAll(value);
        const address = getAddressLineP1T16();

        if (address.length > 61) {
            props.setAddress(props.address);
            changeAddressAll(props.address);
        } else {
            props.setAddress(value);
        }
    };

    const handleSetSuiteRoom = (value) => {
        changeSuiteRoomAll(value);
        const address = getAddressLineP1T16();

        if (address.length > 61) {
            props.setSuiteRoom(props.suiteRoom);
            changeSuiteRoomAll(props.suiteRoom);
        } else {
            props.setSuiteRoom(value);
        }
    };

    const handleSetCity = (value) => {
        changeCityAll(value);
        const address = getAddressLineP1T16();

        if (address.length > 61) {
            props.setCity(props.city);
            changeCityAll(props.city);
        } else {
            props.setCity(value);
        }
    };

    const handleSetZip = (value) => {
        changeZipAll(value);
        const address = getAddressLineP1T16();

        if (address.length > 61) {
            props.setZip(props.zip);
            changeZipAll(props.zip);
        } else {
            props.setZip(value);
        }
    };

    const handleSetLocationAddress = (index, value) => {
        const address = value + ', ' + props.locationSuites[index];

        if (address.length <= 62) {
            setLocationElement(props.locationAddresses1, props.setLocationAddresses1, index, value);
        }
    };

    const handleSetLocationSuite = (index, value) => {
        const address = props.locationAddresses1[index] + ', ' + value;

        if (address.length <= 62) {
            setLocationElement(props.locationSuites, props.setLocationSuites, index, value);
        }
    };

    const handleSetLocationCity = (index, value) => {
        const address = value + ', ' + props.locationStates[index] + ' ' + props.locationZips[index];

        if (address.length <= 62) {
            setLocationElement(props.locationCities, props.setLocationCities, index, value);
        }
    };

    const handleSetLocationZip = (index, value) => {
        const address = props.locationCities[index] + ', ' + props.locationZips[index] + ' ' + value;

        if (address.length <= 62) {
            setLocationElement(props.locationZips, props.setLocationZips, index, value);
        }
    };

    const renderCount = (value, limit) => {
        let count = 0;
        if (value) {
            count = value.length;
        }

        return <div className="limit-message">{count}/{limit} characters</div>;
    };

    const renderLocations = () => {
        let elements = [];
        for (let i = 0; i < props.locations; i++) {
            let address1 = props.locationAddresses1[i];
            if (!isEmpty(props.locationSuites[i])) {
                address1 +=  ', ' + props.locationSuites[i];
            }

            let address2 = '';
            if (!isEmpty(props.locationCities[i])) {
                address2 += props.locationCities[i];
            }
            if (!isEmpty(props.locationStates[i])) {
                address2 += ', ' + props.locationStates[i];
            }
            if (!isEmpty(props.locationZips[i])) {
                address2 += ' ' + props.locationZips[i];
            }

            elements.push(
                <Fragment>
                    <h6>Location {i + 1}:</h6>
                    <TextField
                        label="Clinic Name"
                        placeholder="Clinic Name"
                        limit="64"
                        showCount
                        value={props.locationNames[i]}
                        setFunction={setLocationElement.bind(this, props.locationNames, props.setLocationNames, i)}
                    />
                    <TextField
                        required
                        label="Address"
                        value={props.locationAddresses1[i]}
                        setFunction={handleSetLocationAddress.bind(this, i)}
                    />
                    <TextField
                        label="Ste #"
                        value={props.locationSuites[i]}
                        setFunction={handleSetLocationSuite.bind(this, i)}
                    />
                    {renderCount(address1, 62)}
                    <TextField
                        required
                        label="City"
                        value={props.locationCities[i]}
                        setFunction={handleSetLocationCity.bind(this, i)}
                    />
                    <TextField
                        required
                        label="Zip"
                        value={props.locationZips[i]}
                        setFunction={handleSetLocationZip.bind(this, i)}
                    />
                    {renderCount(address2, 62)}
                    <TextField
                        required
                        isPhone
                        phoneFormat={3}
                        label="Phone"
                        limit="12"
                        value={props.locationPhones[i]}
                        setFunction={setLocationElement.bind(this, props.locationPhones, props.setLocationPhones, i)}
                    />
                    <TextField
                        isPhone
                        phoneFormat={3}
                        label="Fax"
                        limit="12"
                        value={props.locationFaxes[i]}
                        setFunction={setLocationElement.bind(this, props.locationFaxes, props.setLocationFaxes, i)}
                    />
                    <TextField
                        isPhone
                        phoneFormat={3}
                        label="Nurse Phone"
                        limit="12"
                        value={props.locationNursePhones[i]}
                        setFunction={setLocationElement.bind(this, props.locationNursePhones, props.setLocationNursePhones, i)}
                    />
                </Fragment>
            );
        }

        return elements;
    };

    let additionalField = null;
    if (parseInt(props.additionalField) === 1) {
        additionalField = (
            <TextField
                label="Vanity URL"
                value={props.website}
                setFunction={props.setWebsite}
            />
        );
    } else if (parseInt(props.additionalField) === 2) {
        additionalField = (
            <div>
                <TextField
                    label="Email"
                    value={props.email}
                    setFunction={props.setEmail}
                />
                <div className="text-right"><i>@uth.tmc.edu</i></div>
            </div>
        );
    }

    // let paperBullet = null;
    // if (parseInt(props.stock) === 1) {
    //     paperBullet = <li>80# Avalanche Smooth Cover</li>;
    // } else if (parseInt(props.stock) === 2) {
    //     paperBullet = <li>110# Avalanche Smooth Cover</li>;
    // } else if (parseInt(props.stock) === 3) {
    //     paperBullet = <li>130# Avalanche Smooth Cover</li>;
    // }

    return (
        <form action="">
            <hr />
            <TextField
                required
                label="Name"
                limit="55"
                showCount
                placeholder="Name and credentials"
                value={props.name}
                setFunction={props.setName}
            />
            <TextField
                required
                label="Title/Specialty 1"
                limit="61"
                showCount
                value={props.title1}
                setFunction={props.setTitle1}
                placeholder="Title or Specialty Line 1"
            />
            <TextField
                label="Title/Specialty 2"
                limit="61"
                showCount
                value={props.title2}
                setFunction={props.setTitle2}
                placeholder="Title or Specialty Line 2"
            />
            <TextField
                label="Clinic/Department 1"
                limit="55"
                showCount
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Clinic or Department Line 1"
            />
            <TextField
                label="Clinic/Department 2"
                limit="55"
                showCount
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Clinic or Department Line 2"
            />
            <hr />
            <TextField
                required
                label="Address"
                value={props.address}
                setFunction={handleSetAddress}
                placeholder="Address"
            />
            <TextField
                label="Ste #"
                value={props.suiteRoom}
                setFunction={handleSetSuiteRoom}
                placeholder="Ste/Building #"
            />
            <TextField
                required
                label="City"
                value={props.city}
                setFunction={handleSetCity}
            />
            <TextField
                required
                label="Zip"
                value={props.zip}
                setFunction={handleSetZip}
            />
            {renderCount(getAddressLineP1T16(), 61)}
            <TextField
                required
                isPhone
                phoneFormat={3}
                label="Phone"
                limit="12"
                value={props.phone}
                setFunction={props.setPhone}
                placeholder="Main or direct phone number"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Fax"
                limit="12"
                value={props.fax}
                setFunction={props.setFax}
                placeholder="Fax number"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Nurse Phone"
                limit="12"
                value={props.nursePhone}
                setFunction={props.setNursePhone}
                placeholder="Nurse Phone"
            />
            <SelectField
                required
                label="Additional Field"
                value={props.additionalField}
                setFunction={props.setAdditionalField}
                options={[
                    { value: 1, label: 'Website' },
                    { value: 2, label: 'Email' },
                ]}
            />
            {additionalField}
            <hr />
            <SelectField
                required
                label="Select Number of Locations"
                value={props.locations}
                setFunction={props.setLocations}
                options={[
                    { value: 0, label: 0 },
                    { value: 1, label: 1 },
                    { value: 2, label: 2 },
                    { value: 3, label: 3 },
                ]}
            />
            <hr />
            {renderLocations()}
            <hr />
            <SelectField
                required
                label="Stock"
                value={props.stock}
                setFunction={props.setStock}
                options={[
                    { value: '', label: 'Select option' },
                    // { value: 1, label: 'Good' },
                    { value: 2, label: 'Standard' },
                    { value: 3, label: 'Premium' },
                ]}
            />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                    { value: '1500', label: '1500' },
                    { value: '2000', label: '2000' },
                    { value: '5000', label: '5000' },
                    { value: '10000', label: '10000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Co-branded Business Card</div>
                <div className="mt-2">
                    <span className="label">Description:</span> This double-sided, full color business card is available
                    for clinical providers and staff. There is an option to choose between the UT Physicians web address
                    or adding an @uth.tmc.edu email address.
                </div>
                <div className="description-list">
                    <span className="label">Specs:</span>
                    <ul>
                        <li>Variable on both sides</li>
                        <li>3.5x2"</li>
                        <li>Double-sided with Color</li>
                        <li>Uncoated Cover: 100# (Standard) or #130 (Premium)</li>
                    </ul>
                </div>
            </div>
            <h5>Pricing</h5>
            <div className="pricing-container">
                <table className="table table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <th className="text-right">Quantity</th>
                            <th className="text-right">Standard</th>
                            <th className="text-right">Premium</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-right">250</td>
                            <td className="text-right">$45.00</td>
                            <td className="text-right">$55.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">500</td>
                            <td className="text-right">$50.00</td>
                            <td className="text-right">$65.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">1000</td>
                            <td className="text-right">$65.00</td>
                            <td className="text-right">$75.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">1500</td>
                            <td className="text-right">$90.00</td>
                            <td className="text-right">$100.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">2000</td>
                            <td className="text-right">$120.00</td>
                            <td className="text-right">$130.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">5000</td>
                            <td className="text-right">$175.00</td>
                            <td className="text-right">$185.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">10000</td>
                            <td className="text-right">$245.00</td>
                            <td className="text-right">$255.00</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
    );
});

export default FormP1T16;
